import React, { Component } from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  Button,
  ListGroup,
  ListGroupItem,
  InputGroup,
  InputGroupAddon,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
  Alert
} from 'reactstrap';

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      prefectures: null,
      origPrefectures: null,
      page: null,
      totalPages: null,
      origTotalPages: null,
      noSearchResults: false,
      baseEndpoint: '/api/data_exploration/getAllPrefectures'
    };
  }

  componentDidMount() {
    const { baseEndpoint } = this.state;
    this.updatePrefecturesFromEndpoint(baseEndpoint + '/page/1');
  }

  componentDidUpdate(prevProps) {
    const { province } = this.props;

    if(province !== prevProps.province) {
      let baseEndpoint = null;
      if(province) {
        baseEndpoint = '/api/data_exploration/getProvincePrefectures/' + province.id;
      } else {
        baseEndpoint = '/api/data_exploration/getAllPrefectures';
      }
      this.setState({ baseEndpoint: baseEndpoint });
      this.updatePrefecturesFromEndpoint(baseEndpoint + '/page/1');
    }
  }

  updatePrefecturesFromEndpoint(endpoint) {
    fetch(endpoint).then((resp) => resp.json())
      .then((respJson) => {
        this.setState({
          prefectures: respJson.data,
          origPrefectures: respJson.data,
          page: 1,
          totalPages: respJson.total_pages,
          origTotalPages: respJson.total_pages
        });
      });
  }

  handlePrevClick() {
    const { page, baseEndpoint } = this.state;

    fetch(baseEndpoint + '/page/' + (page - 1)).then((resp) => resp.json())
      .then((respJson) => {
        this.setState({
          prefectures: respJson.data,
          page: page - 1,
          noSearchResults: false
        });
      });
  }

  handleNextClick() {
    const { page, baseEndpoint } = this.state;

    fetch(baseEndpoint + '/page/' + (page + 1)).then((resp) => resp.json())
      .then((respJson) => {
        this.setState({
          prefectures: respJson.data,
          page: page + 1,
          noSearchResults: false
        });
      });
  }

  handleSearchChange(e) {
    if(e.target.value === '') {
      this.setState({
        search: e.target.value,
        prefectures: this.state.origPrefectures,
        page: 1,
        totalPages: this.state.origTotalPages,
        noSearchResults: false
      });
    } else {
      this.setState({
        search: e.target.value,
        noSearchResults: false
      });
    }
  }

  handleSearchClick() {
    const { search, baseEndpoint } = this.state;

    fetch(baseEndpoint + '/search/' + search).then((resp) => resp.json())
      .then((respJson) => {
        if(respJson.data.length > 0) {
          this.setState({
            prefectures: respJson.data,
            page: 1,
            totalPages: respJson.total_pages,
            noSearchResults: false
          });
        } else {
          this.setState({
            prefectures: this.state.origPrefectures,
            page: 1,
            totalPages: this.state.origTotalPages,
            noSearchResults: true
          });
        }
      });
  }

  handlePrefectureClick(prefectureId) {
    fetch('/api/prefectures/' + prefectureId).then((resp) => resp.json())
      .then((respJson) => {
        this.props.updatePrefectures({ prefecture: respJson.data });
      });
  }

  render() {
    const { province } = this.props;
    const { page, totalPages, prefectures } = this.state;
    const scopeLabel = province ? province.attributes.name + ' shortlist' : 'All China prefectures';
    const searchResults = prefectures ? prefectures.map((value) => {
      return (
        <ListGroupItem key={value.id} className="sl-prefecture-search-item">
          <div className="sl-prefecture-search-item-main">
            <div>
              <div className="sl-search-result-title">{value.name}</div>
              <div className="sl-search-result-meta">{province ? province.attributes.name + ' province' : 'Prefecture data available'}</div>
            </div>
            <Button
              color="primary"
              size="sm"
              className="sl-inline-action sl-search-result-action"
              onClick={() => this.handlePrefectureClick(value.id)}
              outline>
              Open
            </Button>
          </div>
        </ListGroupItem>
      );
    }) : [];

    return (
      <Card className="mb-0 sl-panel sl-search-panel sl-search-panel-wide">
        <CardHeader className="sl-panel-header sl-search-header-wide">
          <div>
            <div className="sl-search-header-title">Search and browse prefectures</div>
            <div className="sl-search-header-copy">Move laterally across the market without resetting the map workspace above.</div>
          </div>
          <div className="sl-search-header-badge">{page && totalPages ? page + ' / ' + totalPages : 'Loading...'}</div>
        </CardHeader>
        <CardBody>
          {this.state.noSearchResults ? <Alert color="danger">No search results found.</Alert> : null}
          <div className="sl-search-toolbar">
            <div className="sl-search-intro">
              <div>
                <div className="sl-search-intro-label">Current scope</div>
                <div className="sl-search-intro-value">{scopeLabel}</div>
              </div>
            </div>
            <InputGroup className="sl-search-input-group">
              <Input
                value={this.state.search}
                onChange={this.handleSearchChange.bind(this)}
                placeholder="Search prefectures" />
              <InputGroupAddon addonType="append">
                <Button
                  onClick={this.handleSearchClick.bind(this)}
                  color="primary">
                  Search
                </Button>
              </InputGroupAddon>
            </InputGroup>
          </div>
          <ListGroup className="sl-search-results sl-search-results-grid">
            {searchResults}
          </ListGroup>
          <Pagination className="mt-3" listClassName="justify-content-center mb-0">
            <PaginationItem disabled={page === 1}>
              <PaginationLink onClick={this.handlePrevClick.bind(this)}>
                Previous
              </PaginationLink>
            </PaginationItem>
            <PaginationItem disabled={page === totalPages}>
              <PaginationLink onClick={this.handleNextClick.bind(this)}>
                Next
              </PaginationLink>
            </PaginationItem>
          </Pagination>
        </CardBody>
      </Card>
    );
  }
}

export default Search;
